import React from 'react';

import {hasQAIssue} from '../../../../utils/QA';

export function globallyHasQAIssue(rawDataCollection) {
  const {rawAlignments} = rawDataCollection;
  const summary = {};

  rawAlignments.map((aligned) => {
    const {geneSequences} = aligned;
    geneSequences.map((gene) => {
      const geneName = gene.gene;
      if (hasQAIssue(gene)) {
        summary[geneName] = summary[geneName] || 0;
        summary[geneName] += 1;
      }
      return;
    });
    return;
  });

  if (Object.keys(summary).length === 0) {
    return false;
  } else {
    return true;
  }
}

export function getQASummary(rawDataCollection) {
  const {rawAlignments} = rawDataCollection;
  const summary = {};

  rawAlignments.map((aligned) => {
    const {geneSequences} = aligned;
    geneSequences.map((gene) => {
      const geneName = gene.gene;
      if (hasQAIssue(gene)) {
        summary[geneName] = summary[geneName] || 0;
        summary[geneName] += 1;
      }
      return;
    });
    return;
  });

  if (Object.keys(summary).length === 0) {
    return (
      <span>
        No sequence has QA issue.
      </span>
    );
  }

  const spliter = ', ';
  const summary_length = Object.entries(summary).length;
  return (
    <span>
      {'Sequence QA issue: '}
      {Object.entries(summary).map(([gene, number], idx) => {
        const showSpliter = (idx < (summary_length - 1));
        return (
          <span key={idx}>
            {gene}{' '}({number})
            {showSpliter? spliter: null}
          </span>
        );
      })}
    </span>
  );
}



// WEBPACK FOOTER //
// ./src/views/wizard/isolate/upload/utils.js